import { useState } from "react";
import { Col, Row } from "react-grid-system";
import { RiCloseCircleFill, RiEdit2Fill } from "react-icons/ri";
import styled from "styled-components";
import toast, { Toaster } from "react-hot-toast";
import dateFormat, { masks } from "dateformat";

import colors from "../../assets/colors/colors";
import { StyledColor } from '../../interface/index'

import { EditText, EditTextarea } from 'react-edit-text';
import { PostAddPremium_API, PostValidateCodeAdmin, PutEditRestaurant_API } from "../../API";
import CodeScrect from "./CodeSecrect";
import Uploader from "../utils/Uploader";


interface DataUser {
    logo: string
    background: string
    name: string
    description: string
    id: string
    premium: boolean
    location: string

    creation_date: string
    last_edition_date: string
}


interface Props {
    openEditRestaurant: (dt: any) => void
    data: DataUser
    getData: () => void
}

export default function ModalEditBusiness(props: Props) {

    const { data } = props

    const [form, setForm] = useState<any>(data)
    const [changes, setChanges] = useState<boolean>(false)

    const [isLoader, setLoader] = useState<boolean>(false);
    const [codesecret, setCodeSecrect] = useState<string>('');

    const onChange = (value: any, index: any) => {
        form[index] = value;
        setForm({
            ...form,
        });
        setChanges(true)
    };

    const changeSelect = (e: any) => {
        const value = e.target.value
        const index = e.target.id

        setChanges(true)
        form[index] = value
        setForm({
            ...form,
        });

    }

    const onSaveChanges = () => {
        setChanges(true)
    }

    const saveData = async () => {

        const res_code = await PostValidateCodeAdmin(codesecret)

        if (res_code.data.status_code === 400) {
            alert('CODIGO INCORRECTO😡')
            return
        }

        let object = form
        delete object.menu

        setLoader(true)

        const token = localStorage.getItem("token")
        try {

            await PostAddPremium_API(token, {
                id_user: object.id,
                premium: object.premium,
                code: codesecret
            })

            delete object.premium


            await PutEditRestaurant_API(token, object)


            toast.success("Perfil Editado correctamente.");
            setLoader(false)

            props.getData()
            props.openEditRestaurant('')

        } catch (error) {
            toast.error("No se pudo editar el perfil. 😬");
            setLoader(false)
        }
    }


    const handleCode = (code: string) => {
        setCodeSecrect(code)
    }

    return (
        <Content color={colors}>

            <main>
                <header>
                    <h3>Negocio</h3>
                    <span onClick={() => props.openEditRestaurant('')}><RiCloseCircleFill /></span>
                </header>
                <section>
                    <h5>Información</h5>
                    <div>
                        <div className="mb-4">
                            <p> Fecha creación:{" "}
                                {data.creation_date ? (
                                    dateFormat(data.creation_date, "dddd, mmmm dS, yyyy, h:MM:ss TT")
                                )
                                    : 'No disponible'
                                }
                            </p>
                            <p> Ultima actualización:{" "}
                                {data.last_edition_date ? (
                                    dateFormat(data.last_edition_date !== 'string' ? data.last_edition_date : '', "dddd, mmmm dS, yyyy, h:MM:ss TT")
                                )
                                    : 'No disponible'
                                }
                            </p>
                        </div>
                        <Row>
                            <Col>
                                <img src={data.logo} alt="" width={100} />
                                <p><b>Logo</b></p>
                            </Col>
                            <Col>
                                <img src={data.background} alt="" width={100} />
                                <p><b>Background</b></p>
                            </Col>
                        </Row>
                        <ul>
                            <li>
                                <b>Nombre:</b> <br />
                                <EditText
                                    value={form.name}
                                    // defaultValue={data.name}
                                    onChange={(e) => onChange(e, 'name')}
                                    onSave={() => onSaveChanges()}
                                />
                                <RiEdit2Fill
                                    style={{ fontSize: '1.4em', cursor: 'pointer' }}
                                    className="text-dark"
                                />
                            </li>
                            <li><b>Descripcion:</b> <br />
                                <EditText
                                    value={form.description}
                                    // defaultValue={data.description}
                                    onChange={(e) => onChange(e, 'description')}
                                    onSave={() => onSaveChanges()}
                                />
                            </li>
                            <li><b>Email:</b> <br />
                                <p>{form.email}</p>
                            </li>
                            <li><b>Email:</b> <br />
                                <p>{form.phone}</p>
                                {/* <EditText
                                    value={form.description}
                                    // defaultValue={data.description}
                                    onChange={(e) => onChange(e, 'description')}
                                    onSave={() => onSaveChanges()}
                                /> */}
                            </li>
                            <li><b>Ubicacion:</b> <br />
                                <EditText
                                    value={form.location}
                                    defaultValue={data.location}
                                    onChange={(e) => onChange(e, 'location')}
                                    onSave={() => onSaveChanges()}
                                />
                            </li>
                            <li>
                                <b>Estatus:</b><br />
                                <div className="form-group">
                                    <select
                                        className="form-select"
                                        id="premium"
                                        onChange={changeSelect}
                                    >
                                        <option value={'true'} selected={data.premium} >Premium</option>
                                        <option value={'false'} selected={!data.premium} >No Premium</option>
                                    </select>
                                </div>

                            </li>
                        </ul>
                        {
                            changes && (
                                <div>
                                    <CodeScrect
                                        handleCode={handleCode}
                                    />
                                    <div className="w-100 text-center">
                                        <button className="btn btn-success mt-4"
                                            onClick={() => saveData()}
                                        >
                                            Guardar cambios
                                        </button>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                </section>

            </main>
            <Toaster position="bottom-center" reverseOrder={false} />
        </Content>
    )
}


const Content = styled.div<StyledColor>`
    width: 100%;
    min-height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #00000042;
    z-index:10000;
    display:flex;
    flex-direction:column; 
    justify-content:center; 
    align-items:center;
    overflow: scroll !important;
     main {
        width: 50%;
        height: 80vh;
        /* background: #D4E9F7; */
        background: white;
        border-radius: 12px;
        box-shadow: 0px 10px 10px #00000036;
        padding: 2em;
        position: relative;
         overflow: scroll !important;
        header {
            span {
                position: absolute;
                top: 5px;
                right: 5px;
                color: #0000006c !important;
                /* padding: 1em; */
                font-size: 2em;
                cursor:pointer;
            }
        }
        section {
            padding: 1em 0.2em;
        }
        ul {
            list-style: none;
            padding: 0.5em!important;
            margin: 0 !important;
            li {
                padding: 0.5em 0;
            }
        }
    }
`